<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
/**
 * Products component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        total: "",
        state: true,
        id: 0,
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    detalle() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "cotizaciones/view_cotizacion?id=" +
            this.$route.params.id,{
            headers: { "x-token": this.userT.token}
          }
        )
        .then((response) => {
          // console.log("response", response);

          this.formPro.cliente =
            response.data.orden.cliente_rapido != ""
              ? response.data.orden.cliente_rapido
              : response.data.orden.cliente.persona.nombre_persona;
          this.formPro.total = response.data.orden.total;
          this.formPro.dias_vencimiento = response.data.orden.dias_vencimiento;
          this.formPro.no_orden = response.data.orden.no_cotizacion;

          let detalleProducto = response.data.orden.detalle_cotizaciones;
          let detalleServicio = response.data.orden.detalle_servicios;
           console.log('detalle Prod',detalleProducto);
          // console.log(detalleServicio);

          for (let i = 0; i < detalleProducto.length; i++) {
            me.detalleorden.push({
              cantidad: detalleProducto[i].cantidad_venta,
              descripcion:
                detalleProducto[i].stock.producto.nombre_producto +
                (detalleProducto[i].stock.producto.descripcion_producto ==
                  null ||
                detalleProducto[i].stock.producto.descripcion_producto == ""
                  ? ""
                  : " - " +
                    detalleProducto[i].stock.producto.descripcion_producto),
              valor_unitario: detalleProducto[i].precio_venta,
              precio_venta: detalleProducto[i].precio_original,
              subtotal: detalleProducto[i].subtotal_venta,
            });
          }

          for (let i = 0; i < detalleServicio.length; i++) {
            me.detalleorden.push({
              cantidad: detalleServicio[i].cantidad_servicios,
              descripcion:
                detalleServicio[i].servicio.nombre_servicio +
                (detalleServicio[i].servicio.descripcion_servicio == "" ||
                detalleServicio[i].servicio.descripcion_servicio == null
                  ? ""
                  : " - " + detalleServicio[i].servicio.descripcion_servicio),
              valor_unitario: detalleServicio[i].precio_servicio,
              subtotal: detalleServicio[i].subtotal_servicio,
            });
          }
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  /**
   * Total no. of records
   */

  }
};
</script>
<style>
/* .cabezera {
  float-right
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mt-4">
      <div class="col">
        <router-link
          :to="{
            name: 'Cotizacion',
          }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
            ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="card-body">
            <hr />
            <div class="row">
              <div class="col-6">
                <address class="font-size-14">
                  Guatemala, {{ showDate(new Date()) }}
                </address>          
                <address>
                  <strong class="font-size-14">Señor(a)</strong>
                  <p class="font-size-14">
                    {{ this.formPro.cliente }}
                  </p>
                  <p class="font-size-14">Ciudad</p>         
                </address>
              </div>
              <div class="col-6 text-sm-end" align="left">
                <div class="invoice-title">
                  <h4 class="float-left font-size-14">
                    COTIZACIÓN No. {{ this.formPro.no_orden }}
                  </h4>
                </div>
              </div>
            </div>
            <div class="p-2 mt-3">
              <p class="font-size-14">
                En atención a solicitud, nos permitimos cotizar los siguientes
                artículos
              </p>
            </div>
            <div class="table-responsive">
              <table class="table" border="2">
                <thead>
                  <tr>
                    <th>CANTIDAD</th>
                    <th>DESCRIPCIÓN</th>
                    <th>VALOR UNITARIO SIN DESCUENTO</th>
                    <th>VALOR UNITARIO CON DESCUENTO</th>
                    <th>VALOR TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in detalleorden" v-bind:key="idx">
                    <td>{{ item.cantidad }}</td>
                    <td>{{ item.descripcion }}</td>
                    <td>
                      {{ item.precio_venta ? money(item.precio_venta) :  money(item.valor_unitario)  }}
                    </td>
                    <td>
                      {{ money(item.valor_unitario) }}
                    </td>
                    <td>
                      {{ money(item.subtotal) }}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <strong>TOTAL INCLUIDO IVA 16%</strong>
                    </td>
                    <td>
                      <strong class="m-0">
                        {{ money(formPro.total > 0 ? formPro.total : 0.0) }}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="p-2 mt-3">
                <p class="font-size-14">
                  <strong> VIGENCIA DE LA COTIZACIÓN: </strong
                  >{{ formPro.dias_vencimiento }} días
                </p>
                <p class="font-size-14">
                  <strong
                    >*Esta mercancía cuenta con garantía de fábrica</strong
                  >
                </p>
                <p class="font-size-14">
                  En espera que nuestra cotización sea de su total satisfacción
                  y poder atender sus pedidos.
                </p>        
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col">
              <img
                class="img-fluid float-right"
                src="../../../../../src/assets/images/logoZonaR.png"
                alt="Logo"
              />
            </div>
            <div class="col"></div>
            <div class="col"></div>
          </div> -->
        </div>
      </div>
    </div>
  </Layout>
</template>
